export default "__VITE_ASSET___Cd6hJQv__"